module.exports = __webpack_public_path__ + "img/hjk1.82df24d5.jpg";